/* CY FACT ICONS, play once (2026-10-11, owner on the style rule STANDARDS §1.8: "Fact icons: play once"): the dual-tone icons
   of the PDP facts strip and the cart promise strip animate ONCE when they come into view (60% visible), and again when a
   mouse moves onto them; no endless loop on the buy path. The CSS (cy-fact-icons.css) runs the motion only on .cyp-fi.is-play;
   reduced motion: still (the CSS has no motion then). Icons added later (variant change, cart update) are picked up too. */
(() => {
  const play = el => { el.classList.remove('is-play'); void el.getBoundingClientRect(); el.classList.add('is-play'); };
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { io.unobserve(e.target); play(e.target); } }), { threshold: .6 })
    : null;
  const arm = root => (root || document).querySelectorAll('.cyp-fi:not([data-fi-on])').forEach(el => {
    el.dataset.fiOn = '1';
    if (io) io.observe(el); else play(el);
    const host = el.closest('.cyp__fchip, .cyc-prm__ic, .hdt-tcwi-inner') || el.parentElement;
    host && host.parentElement && host.parentElement.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') play(el); });
  });
  const run = () => {
    arm();
    const main = document.querySelector('main') || document.body;
    new MutationObserver(ms => { if (ms.some(m => m.addedNodes.length)) arm(main); }).observe(main, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', e => arm(e.target));
})();
